import React from "react";
import { OurProcessSingle } from "./OurProcessSingle";
import { IoArrowRedoOutline } from "react-icons/io5";
import { TiBatteryLow } from "react-icons/ti";
import { TbFirstAidKit } from "react-icons/tb";
import { FaBookReader } from "react-icons/fa";
import { RiCustomerService2Line } from "react-icons/ri";
import HeadingText from "./atoms/HeadingText";
import { useTranslation } from "react-i18next";

const icons = [
  TiBatteryLow,
  TbFirstAidKit,
  FaBookReader,
  RiCustomerService2Line,
];

const OurProcess = () => {
  const { t } = useTranslation();

  const processes = t("homepage.processes", { returnObjects: true }); // fetch array from translation file

  return (
    <section
      id="our-process"
      className="bg-[url('../src/assets/images/jason-briscoe-GrdJp16CPk8-unsplash.jpg')] w-full h-full bg-cover bg-center my-12"
    >
      <div className="bg-white/75 py-20">
        <div>
          <div className="w-[60%] m-auto text-center mb-2 ">
            <HeadingText classes="text-primary-400">
              {t("homepage.process.heading")}
            </HeadingText>
          </div>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center content-center px-20 py-10">
              {processes.map((process, index) => (
                <OurProcessSingle
                  key={index}
                  process={{
                    headline: process.headline,
                    button: process.button,
                    icon1: IoArrowRedoOutline,
                    icon2: icons[index],
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurProcess;
